import { render, staticRenderFns } from "./ActionTypeAdd.vue?vue&type=template&id=f6cf5d7c&scoped=true"
import script from "./ActionTypeAdd.vue?vue&type=script&lang=js"
export * from "./ActionTypeAdd.vue?vue&type=script&lang=js"
import style0 from "./ActionTypeAdd.vue?vue&type=style&index=0&id=f6cf5d7c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cf5d7c",
  null
  
)

export default component.exports